/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import ImageGallery from 'react-image-gallery';

import { Section, Layout, SEO, StoreBadge } from '..';
import { FaqSection } from './FaqSection';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

import style from './GameUnboxingPage.module.less';

import hero from './assets/heroUnboxing.jpg';
import trap from './assets/bars.png';
import unboxing from './assets/unboxing.png';
import welcome from './assets/welcome.jpg';

// reviewers
import escapemattster from './assets/escapemattster.jpg';
import escaperoomer from './assets/escaperoomer.png';
import escapetheroomers from './assets/escapetheroomers.jpg';
import reviewtheroom from './assets/reviewtheroom.jpg';
import escapegoats from './assets/escapegoats.png';
import borderlinepuzzler from './assets/borderlinepuzzler.jpg';
import chaos from './assets/chaos.png';
import puzzlingCompany from './assets/puzzlingcompany.png';

// blocks
import browser from './assets/browser.png';
import players from './assets/players.png';
import difficulty from './assets/difficulty.png';
import time from './assets/time.png';
import accessibility from './assets/accessibility.png';
import age from './assets/age.png';

// screenshots
import screenshot1 from './assets/Screenshot1.jpg';
import screenshot2 from './assets/Screenshot2.jpg';
import screenshot3 from './assets/Screenshot3.jpg';
import screenshot4 from './assets/Screenshot4.jpg';
import screenshot5 from './assets/Screenshot5.jpg';
import screenshot6 from './assets/Screenshot6.jpg';
import screenshot7 from './assets/Screenshot7.jpg';
import screenshot8 from './assets/Screenshot8.jpg';

// awards
import awardETRBestDigitalGame from './assets/2021_Best_Digital_Game.png';
import awardETRFinalist from './assets/2021_FINALIST.png';
import logo from "./assets/unboxingLogo@2x.png";
import classNames from "classnames";
import walkietalkie from "../GameUnsolvedCasePage/assets/walkietalkie.png";
import teambuilding from "../GameUnsolvedCasePage/assets/teambuilding.jpg";
import arcade from "../GameUnsolvedCasePage/assets/arcade.png";
import watches from "../GameUnsolvedCasePage/assets/watches.png";
import adventure from "../GameUnsolvedCasePage/assets/ck.png";
import collaborative from "../GameUnsolvedCasePage/assets/collaborative.png";
import warehouse from "../GameUnsolvedCasePage/assets/warehouse.png";
import bars from "../GameUnsolvedCasePage/assets/bars.png";

const screenshots = [
  { original: screenshot1 },
  { original: screenshot2 },
  { original: screenshot3 },
  { original: screenshot4 },
  { original: screenshot5 },
  { original: screenshot6 },
  { original: screenshot7 },
  { original: screenshot8 }
];

export const GameUnboxingPage = () => (
  <Layout transparentTop={true}>
    <SEO
      title="Unboxing the Cryptic Killer"
      description="Dive into the thrilling world of Unboxing the Cryptic Killer, an immersive online co-op escape room game. Join detective partners Ally and Old Dog as they solve puzzles, crack codes, and unravel the mystery of the Cryptic Killer in this unique two-player point-and-click adventure. Experience challenging collaborative puzzles, hand-illustrated environments, and an engaging story in this award-winning escape room series by Eleven Puzzles. Play now and test your teamwork skills!"
      image={unboxing}
    />

    <Section className={style.hero} alternate={true} straightTop={true} style={{ backgroundImage: `url(${hero})` }}>
      <div className={style.wrapper}>
        <div className={style.game}>
          <img src={logo} alt="Unboxing the Cryptic Killer" className={style.gameLogo} />
        </div>
      </div>
    </Section>

    <Section className={style.steam}>
      <h1>Available now!</h1>
      <div className={style.row}>
        <div className={style.content}>
          <StoreBadge
            type="Steam Wishlist"
            title="Unboxing the Cryptic Killer"
            link="https://store.steampowered.com/app/2069040/Unboxing_the_mind_of_a_Cryptic_Killer/"
          />
          <StoreBadge
            type="Google Play Download"
            title="Unboxing the Cryptic Killer"
            link="https://play.google.com/store/apps/details?id=com.elevenpuzzles.unboxing"
          />
          <StoreBadge
            type="App Store Download"
            title="Unboxing the Cryptic Killer"
            link="https://apps.apple.com/us/app/unboxing-the-cryptic-killer/id6448352407"
          />
        </div>
      </div>
    </Section>

    <Section className={style.gameStory} alternate={true} style={{ backgroundImage: `url(${welcome})`}}>
      <div className={style.content}>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h1>Co-op puzzle adventure</h1>
            <p>"Unboxing the Cryptic Killer" is an <strong>immersive co-op puzzle game</strong> that cleverly combines the suspense of a mystery thriller with the excitement of an escape room experience.</p>
            <p>Step into the shoes of two detectives as they work together to solve a perplexing case, with much of the action taking place <strong>inside a mysterious box</strong>. This unique aspect of the game adds an extra layer of intrigue and challenge as players navigate their way through stunning hand-drawn environments.</p>
            <p><strong>Communication and collaboration are crucial</strong> as you share crucial information and solve complex puzzles in your pursuit to unmask the killer and unlock the secrets of the box.</p>
          </div>
          <div className={style.image} />
        </div>
      </div>
    </Section>

    <Section className={style.gameFeatures} alternate={false}>
      <div className={style.content}>
        <h1>The only way to escape is to work together</h1>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <p>Two minds are better than one, and the only way you'll be able to crack the Cryptic Killer's codes is by working together. Through separate screens, you and a friend will be given half of a puzzle at each location. Communicate, collaborate, and work together to push your puzzle-solving skills to the limit.</p>
            <p>🤝 Team up and strategize - effective communication and cooperation are key to success</p>
            <p>📝 Decode cryptic messages to unlock the secrets hidden within the mysterious box</p>
            <p>🕹️ Manipulate devices and consoles to uncover new information and advance through the game</p>
            <p>🎮 Dive into engaging retro mini-games that test your skills and teamwork</p>
            <p>🗣️ Engage with trapped NPCs to gather crucial information and gain their trust</p>
            <p>🖊️ Unleash your creativity by drawing on anything - scribble on walls, items, and more to solve puzzles</p>
          </div>
          <div className={style.image}>
            <img src={teambuilding} alt="Adventure" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.featuresList} alternate={true}>
      <div className={style.content}>
        <h1>Features</h1>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Challenging puzzles</h2>
            <p>Immerse yourself in Unboxing the Cryptic Killer's mind-bending enigmas that will push your cognitive abilities to their limits. With intricate puzzles and riddles to unravel, you and your partner must work in tandem to outsmart the killer and solve the case, proving that two heads are indeed better than one.</p>
          </div>
          <div className={style.image}>
            <img src={arcade} alt="Arcade" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Escape a Trap</h2>
            <p>You must navigate a deadly labyrinth of challenges and obstacles set by the cunning murderer. Work together to decipher clues, crack codes, and overcome the twisted games that await you, as you strive to escape the killer's intricate trap and bring him to justice.</p>
          </div>
          <div className={style.image}>
            <img src={trap} alt="Trap"  />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Two Player Co-Op</h2>
            <p>In Unboxing the Cryptic Killer, detectives find themselves isolated from each other. As you encounter unique items and clues distinct from your partner's, your communication skills will be put to the ultimate test!</p>
          </div>
          <div className={style.image}>
            <img src={adventure} alt="Two player coop" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Collaborative Experience</h2>
            <p>Immerse yourself in a truly cooperative gaming adventure, where teamwork and communication are essential for success. Unboxing the Cryptic Killer requires both players to combine their unique perspectives and skills, sharing vital information and insights to solve the puzzles and challenges that stand in their way, as they uncover the truth behind the Cryptic Killer's sinister schemes.</p>
          </div>
          <div className={style.image}>
            <img src={collaborative} alt="collaborative" />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns, style.alternate)}>
          <div className={style.text}>
            <h2>Explore Illustrated Worlds</h2>
            <p>Delve into the captivating hand-drawn environments of Unboxing the Cryptic Killer, where the dark and mysterious atmosphere of the game comes to life through its intricate comic-book-style graphics.</p>
            <p>As you progress, discover the distinct and immersive worlds created for each level, which serve as the perfect backdrop for the suspenseful and thrilling journey you and your partner embark upon.</p>
          </div>
          <div className={style.image}>
            <img src={warehouse} alt="Warehouse " />
          </div>
        </div>
        <div className={classNames(style.row, style.evenColumns)}>
          <div className={style.text}>
            <h2>Draw on… Everything!</h2>
            <p>You can't solve a case without taking notes. At any time in the game, you can whip out a notebook and pen to make notes and scribble on your environment.</p>
          </div>
          <div className={style.image}>
            <img src={bars} alt="Draw on anything" />
          </div>
        </div>
      </div>
    </Section>

    <Section className={style.screenshots} alternate={false}>
      <h1>Game screenshots</h1>
      <ImageGallery
        additionalClass={style.gallery}
        items={screenshots}
        showNav={true}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={false}
      />
    </Section>

    <FaqSection />

    <Section className={style.steam}>
      <h1>Available now!</h1>
      <div className={style.row}>
        <div className={style.content}>
          <StoreBadge
            type="Steam Wishlist"
            title="Unboxing the Cryptic Killer"
            link="https://store.steampowered.com/app/2069040/Unboxing_the_mind_of_a_Cryptic_Killer/"
          />
          <StoreBadge
            type="Google Play Download"
            title="Unboxing the Cryptic Killer"
            link="https://play.google.com/store/apps/details?id=com.elevenpuzzles.unboxing"
          />
          <StoreBadge
            type="App Store Download"
            title="Unboxing the Cryptic Killer"
            link="https://apps.apple.com/us/app/unboxing-the-cryptic-killer/id6448352407"
          />
        </div>
      </div>
    </Section>
  </Layout>
);
